import { useTranslation } from "react-i18next";

function getScoreColor(score) {
    if (score >= 40) return "text-green-600";
    if (score >= 20) return "text-amber-500";
    return "text-red-500";
}

function getBarColor(type) {
    if (type === "very") return "bg-green-500";
    if (type === "somewhat") return "bg-amber-400";
    return "bg-slate-300";
}

export default function PmfScoreCard({ pmfScore, total, breakdown }) {
    const { t } = useTranslation();
    const { veryDisappointed, somewhatDisappointed, notDisappointed } = breakdown;

    const bars = [
        { type: "very", count: veryDisappointed, label: t("survey.very_disappointed") },
        { type: "somewhat", count: somewhatDisappointed, label: t("survey.somewhat_disappointed") },
        { type: "not", count: notDisappointed, label: t("survey.not_disappointed") },
    ];

    return (
        <div className="bg-white rounded-xl border border-slate-200 p-6">
            <div className="text-center mb-8">
                <p className="text-sm text-slate-500 mb-1">{t("survey.admin.pmfScore")}</p>
                <p className={`text-6xl font-bold ${getScoreColor(pmfScore)}`}>
                    {pmfScore}%
                </p>
                <p className="text-sm text-slate-400 mt-1">
                    {t("survey.admin.totalResponses", { count: total })}
                </p>
                <p className="text-xs text-slate-400 mt-1">
                    {pmfScore >= 40
                        ? t("survey.admin.aboveThreshold")
                        : t("survey.admin.belowThreshold")}
                </p>
            </div>
            <div className="space-y-4">
                {bars.map((bar) => {
                    const pct = total > 0 ? Math.round((bar.count / total) * 100) : 0;
                    return (
                        <div key={bar.type}>
                            <div className="flex justify-between text-sm mb-1">
                                <span className="text-slate-700">{bar.label}</span>
                                <span className="text-slate-500">
                                    {bar.count} ({pct}%)
                                </span>
                            </div>
                            <div className="h-3 bg-slate-100 rounded-full overflow-hidden">
                                <div
                                    className={`h-full rounded-full transition-all duration-500 ease-out ${getBarColor(bar.type)}`}
                                    style={{ width: `${pct}%` }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="mt-6 bg-slate-50 rounded-lg p-4">
                <p className="text-xs text-slate-500 leading-relaxed">{t("survey.admin.pmfGuidance")}</p>
            </div>
        </div>
    );
}
